<template>
  <div class="inner">
    <div class="banner-img1"></div>
    <div class="title">适用多样化的考试场景</div>
    <div class="banner-txt">
      <div class="animated fadeInDown slow">
        <div class="banner-info-upper">
          <div class="banner-upper">
            <div class="diamond" @click="goClick(1)">
              <div class="wrap-info"><i class="iconfont iconkaoshi1"></i></div>
              <div class="text">批量校招考试</div>
              <div class="diamond-inner">
                <div class="reverse-text">
                  <div class="inner-title">批量校招考试</div>
                  <span>
                    全球海量考生统考<br />
                    招聘会现场手机考<br />
                    快速淘劣</span
                  >
                </div>
              </div>
            </div>
            <div class="diamond" @click="goClick(2)">
              <div class="wrap-info"><i class="iconfont icongongsi"></i></div>
              <div class="text">企业社招考试</div>
              <div class="diamond-inner">
                <div class="reverse-text">
                  <div class="inner-title">企业社招考试</div>
                  <span> 候选人等候面试时手机考试<br />面试官可多维度考核</span>
                </div>
              </div>
            </div>
            <div class="diamond" @click="goClick(3)">
              <div class="wrap-info">
                <i class="iconfont iconjinshengguanli"></i>
              </div>
              <div class="text">员工晋升考核</div>
              <div class="diamond-inner">
                <div class="reverse-text">
                  <div class="inner-title">员工晋升考核</div>
                  <span
                    >内部员工晋升<br />
                    胜任力达标能力测试<br />
                    素质测评</span
                  >
                </div>
              </div>
            </div>
            <div class="diamond" @click="goClick(4)">
              <div class="wrap-info">
                <i class="iconfont iconjinshengkaohe"></i>
              </div>
              <div class="text">培训认证考核</div>
              <div class="diamond-inner">
                <div class="reverse-text">
                  <div class="inner-title">培训认证考核</div>
                  <span> 培训机构结业认证考核<br />行业从业资格认证考核</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="banner-info-under animated fadeInUp slow">
        <div class="banner-under">
          <div class="diamond" @click="goClick(7)">
            <div class="wrap-info">
              <i class="iconfont iconjingsaiguanli2"></i>
            </div>
            <div class="text">专业知识竞赛</div>
            <div class="diamond-inner">
              <div class="reverse-text">
                <div class="inner-title">专业知识竞赛</div>
                <span> 提供专业知识竞赛平台<br />报名、组队、闯关赛等</span>
              </div>
            </div>
          </div>
          <div class="diamond" @click="goClick(6)">
            <div class="wrap-info"><i class="iconfont iconlianxi"></i></div>
            <div class="text">随堂练习检测</div>
            <div class="diamond-inner">
              <div class="reverse-text">
                <div class="inner-title">随堂练习检测</div>
                <span>
                  学生随堂参加测试<br />考后查看题目解析<br />提升能力</span
                >
              </div>
            </div>
          </div>
          <div class="diamond" @click="goClick(5)">
            <div class="wrap-info"><i class="iconfont iconchengji"></i></div>
            <div class="text">高校招生测评</div>
            <div class="diamond-inner">
              <div class="reverse-text">
                <div class="inner-title">高校招生测评</div>
                <span> 学校招生统一专业能力考试 <br />远程视频面试选拔</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goClick(index) {
      this.$router.push(`/scene?to=section${index}`)
    },
  },
}
</script>
<style lang='scss' scoped>
.inner {
  margin: auto;
  position: relative;
  width: 64rem;
  height: 600px;
}
.banner-img1 {
  width: 100%;
  height: 100%;
  position: absolute;
}
.banner-txt {
  color: #333;
  width: 64rem;
  position: absolute;
  top: 8rem;
  left: 50%;
  margin-left: -34rem;
}
.title {
  font-size: 2rem;
  text-align: center;
  width: 95%;
  padding-top: 10px;
  font-weight: 300;
}
.banner-txt .subtitle {
  font-weight: 300;
  margin-left: 5rem;
  font-size: 2rem;
  letter-spacing: 1.33333rem;
  line-height: 2rem;
}

.banner-info-upper {
  width: 64rem;
  height: 25.83333rem;
  top: 12.16667rem;
}

.banner-info-upper .banner-upper {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.banner-info-upper .banner-upper .diamond {
  width: 15rem;
  height: 15rem;
  background: url('~@/static/images/fangkuai-t.png');
  position: relative;
  cursor: pointer;
  background-size: cover;
  margin-right: 1.2rem;
}
.banner-info-upper .banner-upper .diamond:last-child {
  margin-right: 0px;
}

.banner-info-upper .banner-upper .diamond .wrap-info {
  position: absolute;
  top: 4rem;
  left: 1.5rem;
  width: 12rem;
  text-align: center;
}

.banner-info-upper .banner-upper .diamond .text {
  position: absolute;
  top: 8.5rem;
  font-size: 1rem;
  font-weight: 400;
  text-align: center;
  width: 100%;
}

.banner-info-upper .banner-upper .diamond .white-circle {
  width: 1rem;
  height: 1rem;
  background: #fff;
  border-radius: 0.83333rem;
  margin: 9.83333rem auto 0 9.58333rem;
}

.banner-info-upper .banner-upper .diamond .diamond-inner {
  display: none;
  transform: rotate(-45deg);
}

.banner-info-upper .banner-upper .diamond .reverse-text {
  text-align: center;
  font-size: 1rem;
  display: none;
  color: #fff;
  transform: rotate(45deg);
  span {
    font-size: 0.8rem;
  }
  .inner-title {
    padding: 0px 0px 10px;
  }
}

.banner-info-upper .banner-upper .diamond:hover {
  cursor: pointer;
}

.banner-info-upper .banner-upper .diamond:hover img {
  display: none;
}

.banner-info-upper .banner-upper .diamond:hover .diamond-inner {
  width: 10.5rem;
  height: 10.5rem;
  margin-top: 2.3rem;
  margin-left: 2.25rem;
  position: absolute;
  background: #29bdb9;
  font-size: 14px;
  display: block;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  z-index: 99;
}

.banner-info-upper .banner-upper .diamond:hover .reverse-text {
  display: block;
  font-size: 1rem;
  z-index: 50;
}

.banner-info-under {
  margin-top: -17.8rem;
  margin-left: 7.1rem;
}

.banner-info-under .banner-under {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.banner-info-under .banner-under .diamond {
  width: 15rem;
  height: 15rem;
  background: url('~@/static/images/fangkuai-b.png');
  cursor: pointer;
  background-size: cover;
  margin-left: 1.1rem;
  position: relative;
}

.banner-info-under .banner-under .diamond .wrap-info {
  position: absolute;
  top: 4rem;
  left: 1.5rem;
  width: 12rem;
  text-align: center;
}
.diamond .wrap-info .iconfont {
  font-size: 3rem;
  color: #29bdb9;
}

.banner-info-under .banner-under .diamond .text {
  position: absolute;
  top: 8.5rem;
  left: -2.41667rem;
  width: 19.16667rem;
  font-size: 1rem;
  font-weight: 400;
  text-align: center;
  padding-left: 1.5rem;
  letter-spacing: 0.16667rem;
}

.banner-info-under .banner-under .diamond .white-circle {
  width: 1rem;
  height: 1rem;
  background: #fff;
  border-radius: 0.83333rem;
  margin: 9.83333rem auto 0 9.58333rem;
}

.banner-info-under .banner-under .diamond .diamond-inner {
  display: none;
  transform: rotate(-45deg);
}

.banner-info-under .banner-under .diamond .reverse-text {
  text-align: center;
  font-size: 1rem;
  display: none;
  color: #fff;
  transform: rotate(45deg);
  span {
    font-size: 0.8rem;
  }

  .inner-title {
    padding: 0px 0px 10px;
  }
}

.banner-info-under .banner-under .diamond:hover {
  cursor: pointer;
}

.banner-info-under .banner-under .diamond:hover img {
  display: none;
}

.banner-info-under .banner-under .diamond:hover .diamond-inner {
  width: 10.5rem;
  height: 10.5rem;
  margin-top: 2.3rem;
  margin-left: 2.25rem;
  position: absolute;
  background: #29bdb9;
  font-size: 14px;
  display: block;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  z-index: 99;
}

.banner-info-under .banner-under .diamond:hover .reverse-text {
  display: block;
  z-index: 50;
}
</style>



// WEBPACK FOOTER //
// src/components/home/examsence/pc.vue